import dxFormComponent from 'devextreme-react/form';
import type { FormAction, FormRefType } from './FormProps';
import { PageAction } from '#/app/providers/PageProvider';

const mapAction = <T,>(
  action: FormAction<T>,
  setIsLoading: (isLoading: boolean) => any,
  formRef: React.RefObject<dxFormComponent>,
): PageAction => {
  const btnOnClick = () => {
    if (!action.onClick) {
      return;
    }

    const form = formRef.current?.instance;

    action.onClick({
      form,
      record: form?.option('formData') as T,
      setIsLoading: setIsLoading,
      clearDirty: () => (form as FormRefType | undefined)?.clearDirty?.(),
    });
  };

  if (!action.id && !action.label && !action.icon) {
    console.error(
      'Form action is missing ID, Label and Icon! At least one of them must be set!',
      action,
    );
  }

  const actionItem: PageAction = {
    id: action.id ?? action.label ?? action.icon ?? 'oops',
    alwaysShow: action.type === 'submit',
    type: 'button',
    props: {
      ...action,
      onClick: btnOnClick,
    },
  };

  return actionItem;
};

const mapPageActions = <T,>(
  actions: FormAction<T>[] | undefined,
  setIsLoading: (isLoading: boolean) => any,
  formRef: React.RefObject<dxFormComponent>,
): PageAction[] | undefined =>
  actions?.filter((a) => a.disabled !== true).map((a) => mapAction(a, setIsLoading, formRef));

export default mapPageActions;
